import { filtersHelper } from '@/utils';

export const articleCategoryModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name || '',
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
